import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-datepicker/dist/react-datepicker.css";
import * as actionType from "../../../constants/actionTypes";
import Dropdown, { DropdownSubmenu } from 'react-bootstrap/Dropdown';
import { Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import BlinkingDot from "./BlinkingDot";
import moment from "moment";
import styled from "styled-components";
import { Tooltip } from "@mui/material";


const CustomAdhocCell = ({ row, currentTime, currentDate }) => {
    const [studentAdhocEndTime, setStudentAdhocEndTime] = useState(null);
    const [studentAdhocStatus, setStudentAdhocStatus] = useState(null);
    const [studentAdhocEndDate, setStudentAdhocEndDate] = useState(null);

    const filterData = row?.stu_adhoc_data?.filter((data) => data?.check_in_out === "out");

    useEffect(() => {
        if (filterData.length > 0) {
            const lastAdhocData = filterData[0];
            setStudentAdhocEndTime(moment(lastAdhocData?.end_time, 'HH:mm:ss').format('HH:mm'));
            setStudentAdhocStatus(lastAdhocData?.check_in_out);
            setStudentAdhocEndDate(moment(lastAdhocData?.arrival_date).format('MMMM Do YYYY'));
        }
    }, [filterData]);

    const currentMoment = moment(`${currentDate} ${currentTime}`, 'MMMM Do YYYY HH:mm');
    const studentAdhocEndMoment = moment(`${studentAdhocEndDate} ${studentAdhocEndTime}`, 'MMMM Do YYYY HH:mm');

    const isBlinkDot = currentMoment.isAfter(studentAdhocEndMoment)
        && studentAdhocStatus === "out"
        && row?.stu_adhoc_data.length > 0;
   
    return (
        <div className="h-100 adhoc-hover">
            {console.log(currentMoment.format(), studentAdhocEndMoment.format(), isBlinkDot, row?.stu_adhoc_data.length > 0, "::SDFFF")}

            <span
                className="sub-heading text-center text-white"
                // style={{ opacity: isAnyAdhocToday ? "1" : "0.6" }}
                style={{ opacity: row?.stu_adhoc_data.length ? "1" : "0.6" }}>

                ADHOC <span className={isBlinkDot ? "blinkDot" : ""}></span>
            </span>

            {/* {isAnyAdhocToday && */}
            {row?.stu_adhoc_data.length > 0 && (
                <div className="hover-adhoc text-white" style={{ maxWidth: "200px" }}>
                    {row.stu_adhoc_data.map((item, index) => {
                        // if (!isTodayBetween(item?.departure_date, item?.arrival_date)) return null;

                        return (
                            <div key={index} className="d-flex align-items-center">
                                {(item?.bss_adhoc_leave_detail?.manager_inst.length > 0 ||
                                    item?.bss_adhoc_leave_detail?.parents_inst.length > 0) && (
                                        <span className="text-danger fw-bolder fs-4 me-1">!</span>
                                    )}
                                <span style={{ whiteSpace: "break-spaces" }} className="d-block">
                                    {item?.bss_adhoc_leave_detail?.adhoc_activity_data?.activity_name}:{" "}
                                    {moment(item.start_time, 'HH:mm:ss').format('hh:mm A')} -{" "}
                                    {moment(item?.end_time, 'HH:mm:ss').format('hh:mm A')}
                                </span>
                            </div>
                        );
                    })}
                </div>)}
            {/* )} */}
        </div>
    );
};

//For The Leave Status Expire (Red Blink Dot)
const CustomLeaveCell = ({ row, currentTime, currentDate }) => {
    const [studentLeaveEndTime, setStudentLeaveEndTime] = useState(null);
    const [studentLeaveStatus, setStudentLeaveStatus] = useState(null);
    const [studentLeaveEndDate, setStudentLeaveEndDate] = useState(null);
    useEffect(() => {
        if (row?.stu_leave_data.length > 0) {
            const lastAdhocData = row.stu_leave_data[0];
            setStudentLeaveEndTime(lastAdhocData?.return_students_data?.planned_return_time && moment(lastAdhocData?.return_students_data?.planned_return_time, 'HH:mm:ss').format('HH:mm'));
            setStudentLeaveStatus(lastAdhocData?.check_in_out);
            setStudentLeaveEndDate(lastAdhocData?.return_students_data?.planned_return_date && moment(lastAdhocData?.return_students_data?.planned_return_date).format('MMMM Do YYYY'));
        }

    }, [row?.stu_leave_data]);

    const currentMoment = moment(`${currentDate} ${currentTime}`, 'MMMM Do YYYY HH:mm');
    const studentLeaveEndMoment = moment(`${studentLeaveEndDate} ${studentLeaveEndTime}`, 'MMMM Do YYYY HH:mm');

    const isBlinkDot = currentMoment.isAfter(studentLeaveEndMoment) && studentLeaveStatus === "out" && row?.stu_leave_data?.length > 0;
    console.log(row, row?.stu_leave_data.length, isBlinkDot, "vvvvvvvvvvvvvvvvvvvvvvvvv")
    { console.log(currentMoment?.format(), studentLeaveEndMoment?.format(), studentLeaveEndDate, studentLeaveEndTime, isBlinkDot, row?.stu_leave_data?.length > 0, "::SDxFFF") }

    return (
        <div className=" yellow-light-bg h-100 leave-hover" style={row?.stu_leave_data.length > 0 ? null : { backgroundColor: "rgb(253, 101, 0, 0.5)" }}>
            <span className="sub-heading text-center text-white" style={{ opacity: row?.stu_leave_data.length ? "1" : "0.6" }}>
                Leave <span className={isBlinkDot ? "blinkDot" : ""}></span>
            </span>
            {row?.stu_leave_data.length > 0 &&
                <div className="hover-leave text-white">
                    {row?.stu_leave_data.map((leave, index) => {
                        return (
                            <div style={{ color: "white", marginTop: index == 0 ? "0px" : "10px" }}>
                                {leave?.stu_host_data === null ?
                                    (leave.parent_type === "parent2" ?
                                        <span className="d-block">Host: parent2:{" "}{leave?.parent_data?.parent2_name.charAt(0).toUpperCase() + leave.parent_data?.parent2_name.slice(1)}</span> :
                                        <span className="d-block">Host: parent1:{" "}{leave?.parent_data?.parent1_name.charAt(0).toUpperCase() + leave.parent_data?.parent1_name.slice(1)}</span>) :
                                    <span className="d-block">Host: Name:{" " + (leave?.stu_host_data?.host_name)}</span>

                                }
                                <span className="d-block">Depart:{" " + leave?.departure_date}<span style={{ marginLeft: "5px" }}>{moment(leave?.departure_time, "hh:mm:ss A").format("hh:mm") == "Invalid date" ? "--" : moment(leave?.departure_time, "hh:mm:ss A").format("hh:mm A")}</span></span>
                                <span className="d-block">Return:{" " + leave?.return_date}<span style={{ marginLeft: "5px" }}>{moment(leave?.return_time, "hh:mm:ss A").format("hh:mm") == "Invalid date" ? "--" : moment(leave?.return_time, "hh:mm:ss A").format("hh:mm A")}</span></span>

                            </div>
                        )
                    })}
                </div>
            }
        </div>

    );
};

const SnapshotItem = (props) => {
    const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
    console.log("sssssssssssssssssssss", props)
    const school_code = user_info.school_code;
    const permission_info = JSON.parse(localStorage.getItem("permissions"));
    const comparision = JSON.parse(localStorage.getItem("Comparision"));
    // Default per-page: use provided filterlimit, otherwise default to StudentListcount (All)
    const initialPerpage = (props.filterlimit !== undefined && props.filterlimit !== "" && props.filterlimit !== null) ? props.filterlimit : props.StudentListcount;
    const [perpagedata, setperpagedata] = useState(initialPerpage);
    const role_type = user_info?.role_type
    var on_campus = props.on_campus_location;
    var reasArr1 = props.ReasonData
    var reasArr2 = reasArr1.slice(1, 4)
    var reasArr3 = reasArr2.filter((item) => { if (item.value !== 2) { return item } })
    var reasons = reasArr3
    const [currentTime, setCurrentTime] = useState();
    const [currentDate, setCurrentDate] = useState();

    const [studentAdhocEndTime, setStudentAdhocEndTime] = useState();
    const [studentAdhocStatus, setStudentAdhocStatus] = useState();

    // To get the current time and date only base on school timezone
    const timezone = user_info?.user_school?.timezone;
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(moment().tz(timezone).format('HH:mm'));
            setCurrentDate(moment().tz(timezone).format('MMMM Do YYYY'))
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    const setPerpagePagination = (event) => {
        console.log("sssssssssssssssssssss==============", event.target.value)
        props.propsfilterpage(1);
        setperpagedata(parseInt(event.target.value));
        props.propsfilterlimit(parseInt(event.target.value));
    }

    // If parent hasn't provided a filterlimit, default local display to StudentListcount (show all)
    useEffect(() => {
        if ((props.filterlimit === undefined || props.filterlimit === "" || props.filterlimit === null) && props.StudentListcount) {
            setperpagedata(parseInt(props.StudentListcount));
        }
    }, [props.StudentListcount]);
    const getRowOpacity = (locData) => {
        if (!locData) {
            // First priority: if locData is null
            return 1;
        }

        const {
            current_loc_reason,
            current_present_status,
            previous_reason_id,
            reason_id,
            current_loc_oncampus,
        } = locData;

        const reasonName = current_loc_reason?.reason_name;

        // Priority: if current_loc_reason is null and present status is true
        if (!current_loc_reason && current_present_status === true) return 1;

        // Priority: if previous_reason_id is 5 or 2 → opacity 0.5
        // if (previous_reason_id === 5 || previous_reason_id === 2) return 0.5;

        // Priority: reason_id === 4 → opacity 1
        if (reason_id === 4) return 1;

        // Priority: if reason_id is not null → check reason name
        if (reason_id !== null) {
            if (["SL", "MIA", "ad-hoc"].includes(reasonName)) {
                return 0.5;
            }
            return 1;
        }

        // Priority: if present status is true → opacity 1
        if (current_present_status === true) return 1;

        // Priority: if current_loc_oncampus is not null → opacity 1
        if (current_loc_oncampus !== null) return 1;

        // Fallback default
        return 1;
    };
const StyledTableWrapper =
        props?.data.length > 4
            ? styled.div`
              .custom-table-style.table-fields {
                  display: grid;
                  grid-template-columns: repeat(11, 1fr);
                  gap: 10px;

                  @media (max-width: 2560px) {
                      grid-template-columns: repeat(7, 1fr);
                  }

                  @media (max-width: 1920px) {
                      grid-template-columns: repeat(6, 1fr);
                  }

                  @media (max-width: 1600px) {
                      grid-template-columns: repeat(5, 1fr);
                  }
                      @media (max-width: 1500px) {
    grid-template-columns: repeat(4, 1fr);
}

                  @media (max-width: 1440px) {
                      grid-template-columns: repeat(4, 1fr);
                  }

                  @media (max-width: 1280px) {
                      grid-template-columns: repeat(3, 1fr);
                  }

                  @media (max-width: 1024px) {
                      grid-template-columns: repeat(3, 1fr);
                  }

                  @media (max-width: 768px) {
                      grid-template-columns: repeat(3, 1fr);
                  }

                  @media (max-width: 576px) {
                      grid-template-columns: 1fr;
                  }

                  @media (max-width: 480px) {
                      grid-template-columns: 1fr;
                  }
              }
          `
            : styled.div`
              .custom-table-style.table-fields {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 10px;
              }
          `; 


    const columns = [{
        text: "",
        dataField: "Actions",
        formatter: (cellContent, row, index, extraData) => {
            return (
                <div className="row">
                    <div className="col-sm-12 d-flex">
                        <div className="box-one">
                            <div className="d-flex justify-content-end position-relative" id="cstm-radius"
                                style={
                                    row?.current_loc_data === null
                                        ? { backgroundColor: "transparent" } :
                                        (row?.current_loc_data?.reason_id == 5) ? { backgroundColor: "rgba(253, 225, 1, 0.5)" } : row?.current_loc_data?.reason_id == 2 ? { backgroundColor: "rgba(255, 101, 0, 0.5)" }
                                            : row?.current_loc_data?.reason_id === 4
                                                ? { backgroundColor: "rgba(53, 102, 205, 0.5)" }
                                                : row?.current_loc_data?.reason_id !== null
                                                    ? row?.current_loc_data?.current_loc_reason?.reason_name === "SL"
                                                        ? { backgroundColor: "rgba(255, 101, 0, 0.5)" }
                                                        : row?.current_loc_data?.current_loc_reason?.reason_name === "MIA" ? { backgroundColor: "rgba(203, 0, 50, 0.5)" } : row?.current_loc_data?.current_loc_reason?.reason_name === 'ad-hoc' ? { backgroundColor: "rgba(253, 225, 1, 0.5)" } : { backgroundColor: "transparent" }
                                                    : row?.current_loc_data?.current_present_status === true
                                                        ? { backgroundColor: "transparent" }
                                                        : row?.current_loc_data?.current_loc_oncampus !== null
                                                            ? { backgroundColor: "rgba(53, 102, 205, 0.5)" }
                                                            : { backgroundColor: "transparent" }
                                }
                                   
                            >
                                {console.log(row?.current_loc_data, "row?.current_loc_data row?.current_loc_data ")}

                                
                                <img alt="Logo" className="h-25 alt-img-wrap img-wrap-style"
                                  
                                    style={{ opacity: getRowOpacity(row?.current_loc_data) }}

                                    src={row?.student_avatar === null || row?.student_avatar === '' || row?.display_image_required === false ? row?.gender === 'female' ?
                                        "/media/avatars/girl.jpg" :
                                        "/media/avatars/boy.jpg" : actionType.environment_url + '/' + row?.student_avatar}
               
                                />
                                <div className="justify-content-between top-wrap-block">
                                    <div className="row">
                                        <div className="col-6">
                                            <ul className="list-icons-wrap">
                                                <li>
                                                    {
                                                        role_type === 1 || role_type === 2 || role_type === 3 ?
                                                            (
                                                                // rollcall_compare_status -- check from backend, is_loc_changed--- check from compare rollcall, comparision--- from rollcall to compare or not compare students location
                                                                (
                                                                    row.rollcall_compare_status === true &&
                                                                        row.current_loc_data?.is_loc_changed === true && comparision == 'true' || comparision == true ?
                                                                        // (row.current_loc_data.current_present_status === true && row.current_loc_data.is_loc_changed === true ?
                                                                        (row?.campus_or_reasons_data[0]?.reason_id !== row?.campus_or_reasons_data[1]?.reason_id ||
                                                                            row?.campus_or_reasons_data[0]?.sign_in_out_status !== row?.campus_or_reasons_data[1]?.sign_in_out_status ||
                                                                            row?.campus_or_reasons_data[0]?.on_campus_location_id !== row?.campus_or_reasons_data[1]?.on_campus_location_id
                                                                            ?
                                                                            <div>
                                                                                <div className="ocm-hover h-100 w-10">
                                                                                    <span id={row?.student_id}><BlinkingDot id={row?.student_id} navigateToSnapshot={props.navigateToSnapshot} /></span>
                                                                                    <div className="hover-oc text-white blink-block">
                                                                                        {
                                                                                            // row.current_loc_data.is_loc_changed === true 
                                                                                            row.current_loc_data?.current_present_status === true && row.current_loc_data?.is_loc_changed === false ? "P" :
                                                                                                row.current_loc_data?.current_present_status === true && row?.campus_or_reasons_data[0]?.sign_in_out_status === 2 ?
                                                                                                    (row?.campus_or_reasons_data[0]?.on_campus_location_id === null && row?.campus_or_reasons_data[0]?.reason_id === 4 ? "OC" :
                                                                                                        row?.campus_or_reasons_data[0]?.on_campus_location_id === null && row?.campus_or_reasons_data[0]?.reason_id === 3 ? "KL" :
                                                                                                            row?.campus_or_reasons_data[0]?.on_campus_location_id === null && row?.campus_or_reasons_data[0]?.reason_id === 2 ? "SL" :
                                                                                                                row?.campus_or_reasons_data[0]?.on_campus_location_id === null && row?.campus_or_reasons_data[0]?.reason_id === 1 ? "MIA" :
                                                                                                                    row?.campus_or_reasons_data[0]?.reason_id === null && row?.campus_or_reasons_data[0]?.on_campus_location_id !== null ? "OC" : "OC")
                                                                                                    :
                                                                                                    row.current_loc_data?.current_present_status === false && row?.campus_or_reasons_data[0]?.sign_in_out_status === 1 ?

                                                                                                        (
                                                                                                            row?.campus_or_reasons_data[1]?.sign_in_out_status === 2 ? "P" :
                                                                                                                row?.campus_or_reasons_data[1]?.on_campus_location_id === null && row?.campus_or_reasons_data[1]?.reason_id === 4 ? "OC" :
                                                                                                                    row?.campus_or_reasons_data[1]?.on_campus_location_id === null && row?.campus_or_reasons_data[1]?.reason_id === 3 ? "KL" :
                                                                                                                        row?.campus_or_reasons_data[1]?.on_campus_location_id === null && row?.campus_or_reasons_data[1]?.reason_id === 2 ? "SL" :
                                                                                                                            row?.campus_or_reasons_data[1]?.on_campus_location_id === null && row?.campus_or_reasons_data[1]?.reason_id === 1 ? "MIA" :
                                                                                                                                row?.campus_or_reasons_data[1]?.reason_id === null && row?.campus_or_reasons_data[1]?.on_campus_location_id !== null ? "OC"
                                                                                                                                    : "OC")
                                                                                                        : "OC"
                                                                                        }

                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                            : null)
                                                                        : null)
                                                                // : null)
                                                            )

                                                            : null
                                                    }
                                                </li>
                                                {/* Generic Data */}
                                                <li style={{ width: "20px" }}>
                                                    <span>
                                                        {row.generic_data.length > 0 ?
                                                            <img style={{ background: "#A64D79" }} src="/media/writing.png" alt="" />

                                                            : <img src="/media/writing.png" alt="" style={{ background: "#b1b1b1" }} />
                                                        }
                                                    </span>
                                                    {/* <div className={row?.generic_data == '' ? "" : "hover-block notes-hover"}>{row?.generic_data ? row?.generic_data[0]?.generic_desc : ""}</div> */}

                                                    <div className={row?.generic_data == '' ? "" : "hover-block notes-hover"}>
                                                        {row?.generic_data ? row.generic_data.map((item, index) => (
                                                            <React.Fragment key={index}>
                                                                {item.generic_desc}
                                                                <br />
                                                            </React.Fragment>
                                                        )) : ""
                                                        }
                                                    </div>
                                                 

                                                </li>
                                                {/* Allergy Details */}
                                                <li style={{ width: "20px" }}>
                                                    <span>
                                                        {row.allergy_details.length > 0 ?
                                                            <img style={{ background: "#49BBFB" }} src="/media/letter-a.png" alt="" />
                                                            :
                                                            <img src="/media/letter-a.png" alt="" style={{ background: "#b1b1b1" }} />
                                                        }
                                                    </span>
                                                    <div className={row?.allergy_details == '' ? "" : "hover-block bluish-hover"}>{Array.isArray(row?.allergy_details) ?
                                                        row?.allergy_details.map(item => { return <li>{item.allergy_name}</li> })
                                                        : ""}
                                                    </div>
                                                </li>
                                                {/* Grounded Data */}
                                                <li style={{ width: "20px" }}>
                                                    <span>
                                                        {row.grounded_data.length > 0 ?
                                                            <img style={{ background: "#7239EA" }} src="/media/anchor-new.png" alt="" />
                                                            :
                                                            <img src="/media/anchor-new.png" alt="" style={{ background: "#b1b1b1" }} />
                                                        }
                                                    </span>
                                                    <div className={row?.grounded_data == '' ? "" : "hover-block purple-hover"}>
                                                        <div>
                                                            {console.log(row?.grounded_data[0], "dataaaaaaaaaaaaaaaaaaaaaaaaa")}
                                                            {row?.grounded_data ? row?.grounded_data[0]?.snapshot_desc : ""}
                                                        </div>
                                                        <div>
                                                            {row?.grounded_data.length > 0 ? `${row?.grounded_data[0]?.grounded_start_date} to ${row?.grounded_data[0]?.grounded_end_date}` : ""}

                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-6 mb-3 p-0">
                                            <div class="row me-1">
                                                <div className="text-end p-0">
                                                    {
                                                        ((row?.current_loc_data?.current_loc_reason?.reason_name != "SL" && row?.current_loc_data?.current_loc_reason?.reason_name != "ad-hoc") || row?.current_loc_data?.reason_id == 5) &&
                                                        <input
                                                            className="form-check-input m-0 "
                                                            type="checkbox"
                                                            stu_id={row.student_id}
                                                            value={row.checked}
                                                            checked={row.checked}
                                                            onClick={(event) => {
                                                                props.toggleChecked(event);
                                                            }}
                                                            disabled={props.edit_snapshot_perm === false}
                                                        >
                                                        </input>
                                                    }
                                                </div>
                                            </div>
                                            <div className="row btn-menu me-0">
                                                <div className="text-end p-0">
                                                    {row.checked && props.reason_Name && ((row?.current_loc_data?.current_loc_reason?.reason_name != "SL" && row?.current_loc_data?.current_loc_reason?.reason_name != "ad-hoc") || row?.current_loc_data?.reason_id == 5) ?
                                                        <span className="text-white d-inline-block mx-1" style={{ backgroundColor: '#009A66', borderRadius: '10px', padding: '4px 10px', maxWidth: '100%', whiteSpace: 'normal', wordBreak: 'break-word', fontSize: '0.75rem', lineHeight: '1.2', textAlign: 'center' }}>
                                                            {row.current_loc_data ?
                                                                (props.reason_Name &&
                                                                    row.current_loc_data.current_loc_oncampus ?
                                                                    (row.current_loc_data.current_loc_oncampus.location_name != props.reason_Name ?
                                                                        props.reason_Name : props.reason_Name) :
                                                                    row.current_loc_data.current_loc_reason ?
                                                                        (row.current_loc_data.current_loc_reason.reason_name !== props.reason_Name ?
                                                                            props.reason_Name : props.reason_Name) :
                                                                        row.current_loc_data.current_present_status === true ?
                                                                            (props.reason_Name !== 'present' ? props.reason_Name : props.reason_Name)
                                                                            : props.reason_Name
                                                                ) : props.reason_Name}
                                                        </span>
                                                        :
                                                        <Dropdown>
                                                            <Dropdown.Toggle id="dropdown-basic">
                                                                <img src="/media/menu.png" alt="" />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>

                                                                {/* <ul className="list">   */}
                                                                {/* {console.log("data",row?.current_loc_data?.current_loc_oncampus === null && row?.current_loc_data?.current_loc_reason === null)} */}

                                                                {/* Condition to show change status when status is present */}
                                                                {/* {row?.current_loc_data?.current_loc_oncampus === null && row?.current_loc_data?.current_loc_reason === null ? */}
                                                                {row?.current_loc_data?.current_loc_reason?.reason_name === "SL" ?
                                                                    <Dropdown.Item>
                                                                        <button className="btn-menu" onClick={() => props.showReturnApprovalModal(true, row)} disabled={props.edit_snapshot_perm === false}>
                                                                            Return Student
                                                                        </button>
                                                                    </Dropdown.Item> :
                                                                    <div>
                                                                        {/* <li className="subdropblock"> */}
                                                                        {/* <Dropdown.Toggle > */}
                                                                        <div >
                                                                           
                                                                        </div>
                                                                        <div >
                                                                            <Dropdown className="new">
                                                                                <Dropdown.Toggle id="dropdown-basic" disabled={props.edit_snapshot_perm === false}>
                                                                                    Change Status
                                                                                </Dropdown.Toggle>

                                                                                <Dropdown.Menu>
                                                                                    {reasons?.map(item => {
                                                                                        console.log(item, "324234fdf")
                                                                                        return < Dropdown.Item
                                                                                            style={row?.current_loc_data?.reason_id === item?.reason_Id ? { opacity: "0.6" } : { opacity: "1" }}
                                                                                            disabled={row?.current_loc_data?.reason_id === item?.reason_Id ? true : false}
                                                                                        >
                                                                                            <button className="btn-menu xx"
                                                                                                style={{ color: "white", fontsize: "10px", }}
                                                                                                id={row?.student_id}
                                                                                                reason={item?.reason_Id}
                                                                                                // onClick={(event) => {
                                                                                                //    
                                                                                                //     props.ChangeStatus(event);   
                                                                                                // }}
                                                                                                onClick={(e) => {
                                                                                                    console.log("Checking OnClick in dropdown", row.student_id)
                                                                                                    props?.ChangeStatus(e);
                                                                                                }}
                                                                                            >
                                                                                                {item?.label}
                                                                                            </button>
                                                                                        </Dropdown.Item>
                                                                                    })}



                                                                                    <Dropdown>
                                                                                        <Dropdown.Toggle id="dropdown-basic">
                                                                                            On Campus
                                                                                        </Dropdown.Toggle>
                                                                                        <Dropdown.Menu>
                                                                                            {on_campus?.map(item => {
                                                                                                return <Dropdown.Item
                                                                                                    style={row?.current_loc_data?.on_campus_location_id === item?.on_campus_location_id ? { opacity: "0.6" } : { opacity: "1" }}
                                                                                                    disabled={row?.current_loc_data?.on_campus_location_id === item?.on_campus_location_id ? true : false}
                                                                                                >
                                                                                                    <button
                                                                                                        style={{ color: "white", fontsize: "10px" }}
                                                                                                        id={row?.student_id}
                                                                                                        reason={4}
                                                                                                        campus={item?.on_campus_location_id}
                                                                                                        onClick={(e) => {
                                                                                                            props.ChangeStatus(e)
                                                                                                        }
                                                                                                        }
                                                                                                    >
                                                                                                        {item?.location_name}
                                                                                                    </button>
                                                                                                </Dropdown.Item>
                                                                                            })}
                                                                                        </Dropdown.Menu>
                                                                                    </Dropdown>



                                                                                    <Dropdown.Item id={row.student_id}
                                                                                        style={row?.current_loc_data?.current_present_status === true ? { opacity: "0.6" } : { opacity: "1" }}
                                                                                        disabled={row?.current_loc_data?.current_present_status === true ? true : false}
                                                                                        stu_reason_oncampus_uuid={row.campus_or_reasons_data.length === 0 ?
                                                                                            "" :
                                                                                            row.campus_or_reasons_data[0].stu_reason_oncampus_uuid}
                                                                                        onClick={(event) => {
                                                                                            props.ChangeStatusPresent(event);
                                                                                        }} >
                                                                                        Present
                                                                                    </Dropdown.Item>
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </div>
                                                                    </div>
                                                                }

                                                             


                                                                {/* <li><Link class="dropdown-item" to={`/${school_code}/student/student-list/leave-history/${row.student_uuid}`}>Leave</Link></li> */}
                                                                {/* <li><Link class="dropdown-item" to={`/${school_code}/student/student-list/adhoc-leave/${row.student_uuid}`}>AdHoc</Link></li> */}
                                                                <li><Link class="dropdown-item" to={`/${school_code}/student/student-list/pastoral-notes/${row.student_uuid}`}>Pastoral Notes</Link></li>
                                                                {/* <li><Link class="dropdown-item" to={`/${school_code}/student/student-list/student-profile/${row.student_uuid}`}>Student File</Link></li> */}

                                                                <div >
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle id="dropdown-basic">
                                                                            Rollcall History
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item>
                                                                                {/* <li> */}
                                                                                <button className="btn-menu"
                                                                                    style={{ color: "white", fontsize: "10px", }}
                                                                                    student_uuid={row.student_uuid}
                                                                                    dormitory_name={row.dormitory_data.dormitory_name}
                                                                                    search_by_days="7"
                                                                                    onClick={(event) => {
                                                                                        props.GetEventHandler(event);
                                                                                    }}>7 Days</button>
                                                                                {/* </li> */}

                                                                            </Dropdown.Item>

                                                                            <Dropdown.Item>
                                                                                <button
                                                                                    style={{ color: "white", fontsize: "10px", }}
                                                                                    student_uuid={row.student_uuid}
                                                                                    dormitory_name={row.dormitory_data.dormitory_name}
                                                                                    search_by_days="14"
                                                                                    onClick={(event) => {
                                                                                        props.GetEventHandler(event);
                                                                                    }}>14 Days
                                                                                </button>
                                                                            </Dropdown.Item>

                                                                            <Dropdown.Item>

                                                                                <button
                                                                                    style={{ color: "white", fontsize: "10px", }}
                                                                                    student_uuid={row.student_uuid}
                                                                                    dormitory_name={row.dormitory_data.dormitory_name}
                                                                                    search_by_days="21"
                                                                                    onClick={(event) => {
                                                                                        props.GetEventHandler(event);
                                                                                    }}>21 Days</button>
                                                                            </Dropdown.Item>

                                                                            <Dropdown.Item>
                                                                                <button
                                                                                    style={{ color: "white", fontsize: "10px", }}
                                                                                    student_uuid={row.student_uuid}
                                                                                    dormitory_name={row.dormitory_data.dormitory_name}
                                                                                    search_by_days="28"
                                                                                    onClick={(event) => {
                                                                                        props.GetEventHandler(event);
                                                                                    }}>28 Days</button>

                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                                {/* </ul> */}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>


                                <div
                                    // (row?.current_loc_data?.previous_reason_id == 5) ? {backgroundColor: "rgba(253, 225, 1, 0.5)"} : row?.current_loc_data?.previous_reason_id == 2 ? { backgroundColor: "rgba(255, 101, 0, 0.5)" }
                                    className="info-wrap "
                                    style={{
                                        backgroundColor: row?.current_loc_data?.current_loc_reason?.reason_name === "MIA" ? 'rgb(215, 24, 24,0.7)' :
                                            row?.current_loc_data?.current_loc_reason?.reason_name === "ad-hoc" || row?.current_loc_data?.reason_id == 5 ? "#ffc700a6" :
                                                row?.current_loc_data?.current_loc_reason?.reason_name === "SL" ? "#ff650099" :
                                                    row?.current_loc_data?.current_present_status === true ? 'rgb(28, 26, 26,0.7)' :
                                                        row?.current_loc_data?.reason_id === 4 || row?.current_loc_data?.current_loc_oncampus !== null ? "rgba(53, 102, 205, 0.7)" : row?.current_loc_data?.current_loc_reason == null ? 'rgba(28, 26, 26, 0.7)'
                                                            : 'rgb(28, 26, 26,0.7)'
                                    }}
                                >
                                    <div className="d-flex justify-content-between align-items-center" id="mobile_heading">
                                        <h4 className="text-center" style={{ width: "62px", flexShrink: "0" }}>Rollcall</h4>
                                        <h4 className="text-center" style={{ width: "62px", flexShrink: "0" }}>Adhoc</h4>
                                        <h4 className="text-center" style={{ width: "62px", flexShrink: "0" }}>Leave</h4>
                                    </div>
                                    <div className="d-flex mb-1 justify-content-between snapshot-items">
                                        <div className=" d-flex  w-100" style={{ gap: "5px" }}>
                                            <div className="black-light-bg ocm-hover h-100">
                                                <span className="single-word-wrap"
                                                    style={
                                                        row?.current_loc_data === null ? { color: "#3566CD" } :
                                                            row?.current_loc_data?.reason_id === 4 ? { color: "#3566CD" } :
                                                                row?.current_loc_data?.reason_id !== null &&
                                                                    row?.current_loc_data?.current_loc_reason?.reason_name === "SL" ? { color: "#FF6500" } :
                                                                    row?.current_loc_data?.current_loc_reason?.reason_name === "KL" ? { color: "#0DC0FF" } :
                                                                        row?.current_loc_data?.current_loc_reason?.reason_name === "ad-hoc" ? { color: "#FDE101" } :
                                                                            row?.current_loc_data?.current_loc_reason?.reason_name === "MIA" ? { color: "#CB0032" } :
                                                                                row?.current_loc_data?.current_present_status === true ? { color: "#009A66" } :
                                                                                    row?.current_loc_data?.current_loc_oncampus !== null ? { color: "#3566CD" } : { color: "#009A66" }
                                                    }
                                                >
                                                    {row?.current_loc_data === null ? "OC" :
                                                        row?.current_loc_data?.reason_id === 4 ? "OC" :
                                                            row?.current_loc_data?.reason_id !== null &&
                                                                row?.current_loc_data?.current_loc_reason?.reason_name === "SL" ? "L" :
                                                                row?.current_loc_data?.current_loc_reason?.reason_name === "ad-hoc" ? "AD" :
                                                                    row?.current_loc_data?.current_loc_reason?.reason_name === "KL" ? "KL" :
                                                                        row?.current_loc_data?.current_loc_reason?.reason_name === "MIA" ? "MIA" :
                                                                            row?.current_loc_data?.current_present_status === true ? "P" :
                                                                                row?.current_loc_data?.current_loc_oncampus !== null ? "OC" : "I"
                                                    }
                                                </span>

                                                {row.stu_atten_details.length === 0 ? null :
                                                    <div className="hover-oc">{console.log(row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name, "::datdat")}
                                                        <div className="d-flex justify-content-end">
                                                            {row.stu_atten_details[0] ?
                                                                <span
                                                                    // className={row?.stu_atten_details[0] ? row?.stu_atten_details[0]?.is_attendance === false ? row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "MIA" ? "text-danger" : "" : "" : ""}
                                                                    style={{
                                                                        ...(row?.stu_atten_details[0] && row?.stu_atten_details[0]?.is_attendance === true ? { color: "#009A66" } :
                                                                            row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "On Campus" ? { color: "#3566CD" } :
                                                                                row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "SL" ? { color: "#FF6500" } :
                                                                                    row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "KL" ? { color: "#0DC0FF" } :
                                                                                        row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "ad-hoc" ? { color: "#FDE101" } :
                                                                                            row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "MIA" ? { color: "#CB0032" } : { color: "#009A66" }),
                                                                        // marginRight: "13px"
                                                                    }}
                                                                >
                                                                    {row?.stu_atten_details[0] ? row?.stu_atten_details[0]?.is_attendance === true ? "P" :
                                                                        row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "On Campus" ? "OC" :
                                                                            row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "SL" ? "L" :
                                                                                row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name === "ad-hoc" ? "AD" :
                                                                                    row?.stu_atten_details[0]?.attendance_reason[0]?.reason_name : ""
                                                                    }
                                                                </span>
                                                                : ""
                                                            }

                                                            {row.stu_atten_details[1] ?
                                                                <span
                                                                    // className={row?.stu_atten_details[1] ? row?.stu_atten_details[1]?.is_attendance === false ? row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "MIA" ? "text-danger" : "" : "" : ""}
                                                                    style={row?.stu_atten_details[1] && row?.stu_atten_details[1]?.is_attendance === true ? { color: "#009A66" } :
                                                                        row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "On Campus" ? { color: "#3566CD" } :
                                                                            row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "SL" ? { color: "#FF6500" } :
                                                                                row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "KL" ? { color: "#0DC0FF" } :
                                                                                    row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "ad-hoc" ? { color: "#FDE101" } :
                                                                                        row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "MIA" ? { color: "#CB0032" } : { color: "#009A66" }
                                                                    }
                                                                >
                                                                    {row?.stu_atten_details[1] ? row?.stu_atten_details[1]?.is_attendance === true ? "P" :
                                                                        row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "On Campus" ? "OC" :
                                                                            row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "SL" ? "L" :
                                                                                row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name === "ad-hoc" ? "AD" :
                                                                                    row?.stu_atten_details[1]?.attendance_reason[0]?.reason_name : ""
                                                                    }
                                                                </span>
                                                                : ""
                                                            }

                                                            {row?.stu_atten_details[2] ?
                                                                <span
                                                                    // className={row?.stu_atten_details[2] ? row?.stu_atten_details[2]?.is_attendance === false ? row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "MIA" ? "text-danger" : "" : "" : ""}
                                                                    style={row?.stu_atten_details[2] && row?.stu_atten_details[2]?.is_attendance === true ? { color: "#009A66" } :
                                                                        row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "On Campus" ? { color: "#3566CD" } :
                                                                            row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "SL" ? { color: "#FF6500" } :
                                                                                row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "KL" ? { color: "#0DC0FF" } :
                                                                                    row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "ad-hoc" ? { color: "#FDE101" } :
                                                                                        row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "MIA" ? { color: "#CB0032" } : { color: "#009A66" }
                                                                    }
                                                                >
                                                                    {row?.stu_atten_details[2] ? row?.stu_atten_details[2]?.is_attendance === true ? "P" :
                                                                        row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "On Campus" ? "OC" :
                                                                            row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "SL" ? "L" :
                                                                                row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name === "ad-hoc" ? "AD" :
                                                                                    row?.stu_atten_details[2]?.attendance_reason[0]?.reason_name : ""
                                                                    }
                                                                </span>
                                                                : ""
                                                            }

                                                            {row?.stu_atten_details[3] ?
                                                                <span
                                                                    // className={row?.stu_atten_details[3] ? row?.stu_atten_details[3]?.is_attendance === false ? row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "MIA" ? "text-danger" : "" : "" : ""}
                                                                    style={row?.stu_atten_details[3] && row?.stu_atten_details[3]?.is_attendance === true ? { color: "#009A66" } :
                                                                        row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "On Campus" ? { color: "#3566CD" } :
                                                                            row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "SL" ? { color: "#FF6500" } :
                                                                                row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "KL" ? { color: "#0DC0FF" } :
                                                                                    row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "ad-hoc" ? { color: "#FDE101" } :
                                                                                        row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "MIA" ? { color: "#CB0032" } : { color: "#009A66" }
                                                                    }
                                                                >
                                                                    {row?.stu_atten_details[3] ? row?.stu_atten_details[3]?.is_attendance === true ? "P" :
                                                                        row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "On Campus" ? "OC" :
                                                                            row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "SL" ? "L" :
                                                                                row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name === "ad-hoc" ? "AD" :
                                                                                    row?.stu_atten_details[3]?.attendance_reason[0]?.reason_name : ""
                                                                    }
                                                                </span>
                                                                : ""
                                                            }

                                                            {row?.stu_atten_details[4] ?
                                                                <span
                                                                    // className={row?.stu_atten_details[4] ? row?.stu_atten_details[4]?.is_attendance === false ? row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "MIA" ? "text-danger" : "" : "" : ""}
                                                                    style={row?.stu_atten_details[4] && row?.stu_atten_details[4]?.is_attendance === true ? { color: "#009A66" } :
                                                                        row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "On Campus" ? { color: "#3566CD" } :
                                                                            row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "SL" ? { color: "#FF6500" } :
                                                                                row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "KL" ? { color: "#0DC0FF" } :
                                                                                    row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "ad-hoc" ? { color: "#FDE101" } :
                                                                                        row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "MIA" ? { color: "#CB0032" } : { color: "#009A66" }
                                                                    }
                                                                >
                                                                    {row?.stu_atten_details[4] ? row?.stu_atten_details[4]?.is_attendance === true ? "P" :
                                                                        row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "On Campus" ? "OC" :
                                                                            row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "SL" ? "L" :
                                                                                row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name === "ad-hoc" ? "AD" :
                                                                                    row?.stu_atten_details[4]?.attendance_reason[0]?.reason_name : ""
                                                                    }
                                                                </span>
                                                                : ""
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <CustomAdhocCell row={row} currentTime={currentTime} currentDate={currentDate} />
                                            <CustomLeaveCell row={row} currentTime={currentTime} currentDate={currentDate} />
                                        </div>
                                    </div>

                                    {/* <p className="text-white m-0">Location  {row?.current_loc_data?.current_loc_oncampus === null ? "" : ": " + `${row?.current_loc_data?.current_loc_oncampus?.location_name === undefined ? "Dormitory" : row?.current_loc_data?.current_loc_oncampus?.location_name}`}</p> */}
                                    <p className="text-white m-0">
                                        {
                                            (row?.current_loc_data?.current_loc_reason?.reason_name === "ad-hoc" &&
                                                row?.stu_adhoc_data[0]?.check_in_out === "out")
                                                ? <svg width="12" height="18" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 0C3.802 0 0 3.403 0 7.602C0 11.8 3.469 16.812 8 24C12.531 16.812 16 11.8 16 7.602C16 3.403 12.199 0 8 0ZM8 11C6.343 11 5 9.657 5 8C5 6.343 6.343 5 8 5C9.657 5 11 6.343 11 8C11 9.657 9.657 11 8 11Z" fill="black" />
                                                </svg>
                                                : "Location:"
                                        }
                                        {console.log("row#@EE@#@#@", row)}
                                        {
                                            row?.current_loc_data?.current_present_status === true
                                                ? " Dormitory"
                                                : row?.current_loc_data?.current_loc_reason?.reason_name === "SL"
                                                    ? " Leave"
                                                    : row?.current_loc_data?.current_loc_reason !== null
                                                        ? (
                                                            row?.current_loc_data?.current_loc_reason?.reason_name === "ad-hoc" &&
                                                            row?.stu_adhoc_data[0]?.check_in_out === "out"
                                                        )
                                                            ? " " + row?.stu_adhoc_data[0]?.bss_adhoc_leave_detail?.adhoc_activity_data?.activity_name
                                                            : row?.current_loc_data?.current_loc_reason?.reason_name === "SL"
                                                                ? ""
                                                                : row?.current_loc_data?.current_loc_reason?.reason_name === "On Campus"
                                                                    ? " " + row?.current_loc_data?.current_loc_reason?.reason_name +
                                                                    (row?.current_loc_data?.current_loc_oncampus?.location_name
                                                                        ? " - " + row?.current_loc_data?.current_loc_oncampus?.location_name
                                                                        : "")
                                                                    : " " + row?.current_loc_data?.current_loc_reason?.reason_name
                                                        : " " + row?.current_loc_data?.current_loc_oncampus?.location_name
                                        }
                                        {
                                            (row?.current_loc_data?.current_loc_reason?.reason_name === "ad-hoc" &&
                                                row?.stu_adhoc_data[0]?.check_in_out === "out") &&
                                            (() => {
                                                const adhoc = row.stu_adhoc_data[0];
                                                const outTime = adhoc?.actual_start_time || adhoc?.start_time;
                                                if (!outTime || !adhoc?.departure_date) return null;

                                                const signOutMoment = moment(`${moment(adhoc.departure_date).format('YYYY-MM-DD')} ${outTime}`, 'YYYY-MM-DD HH:mm:ss');
                                                if (!signOutMoment.isValid()) return null;

                                                const todayStr = moment().tz(timezone).format('YYYY-MM-DD');
                                                const dateSuffix = signOutMoment.format('YYYY-MM-DD') !== todayStr ? ` (${signOutMoment.format('DD MMM')})` : '';

                                                return (
                                                    <span>
                                                        {" "}- Signed Out: {signOutMoment.format('h:mm A')}{dateSuffix}
                                                    </span>
                                                );
                                            })()
                                        }


                                    </p>
                                </div>
                            </div>
                            <div className="box-txt">
                                <div className="row">
                                  
                                    <div className="col-7">
                                        <Tooltip placement="top"
                                            title={
                                                row.student_first_name && row.student_last_name
                                                    ? row.student_first_name?.charAt(0).toUpperCase() +
                                                    row.student_first_name?.slice(1) +
                                                    ' ' +
                                                    row.student_last_name
                                                    : ''
                                            }

                                        >
                                            <Link
                                                to={`/${school_code}/student/student-list/student-profile/${row.student_uuid}`}

                                            >
                                             

                                                <h6 className="text-black fw-bolder">
                                                    {(
                                                        (row.student_first_name?.charAt(0).toUpperCase() +
                                                            row.student_first_name?.slice(1) +
                                                            ' ' +
                                                            row.student_last_name) || ''
                                                    ).length > 15
                                                        ? (
                                                            row.student_first_name?.charAt(0).toUpperCase() +
                                                            row.student_first_name?.slice(1) +
                                                            ' ' +
                                                            row.student_last_name
                                                        ).slice(0, 15) + '...'
                                                        : row.student_first_name?.charAt(0).toUpperCase() +
                                                        row.student_first_name?.slice(1) +
                                                        ' ' +
                                                        row.student_last_name}
                                                </h6>
                                            </Link>
                                        </Tooltip>
                                    </div>

                                    <div className="col-5 pe-0">
                                        <p className="mb-0 text-black">{row.class_name.charAt(0).toUpperCase() + row.class_name.slice(1)}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-7 col-sm-7 col-7">
                                        <p className="mb-0 text-black">{row.dormitory_data.dormitory_name.charAt(0).toUpperCase() + row.dormitory_data.dormitory_name.slice(1)}{ }</p>
                                        <p className="mb-0 text-black">{row.sporting_house != "" ? row.sporting_house : "Sporting House"}</p>

                                    </div>

                                    <div className="col-md-5 col-sm-5 col-5 pe-0">

                                        <span className="text-black d-block">{row.unique_pin.charAt(0).toUpperCase() + row.unique_pin.slice(1)}</span>
                                        <p className="mb-0 text-black">{row.gender.charAt(0).toUpperCase() + row.gender.slice(1)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            );
        },
    }]
    const handleTableChange = (type, { sortField, sortOrder, page }) => {
        if (type === "sort") {
            props.propsfiltersort(sortField);
            props.propsfilterorder(sortOrder);
        }

        if (type === "pagination") {
            props.propsfilterpage(page);
        }

    };
    const RemotePagination = ({ columns, dataField, order, data, page, sizePerPage, onTableChange, totalSize }) => {
        const totalPages = sizePerPage && sizePerPage < totalSize ? Math.ceil(totalSize / sizePerPage) : 1;
        const currentPage = page || 1;

        const handlePageClick = (newPage) => {
            if (newPage < 1 || newPage > totalPages || newPage === currentPage) return;
            onTableChange('pagination', { page: newPage });
        };

        const renderPageButtons = () => {
            const buttons = [];
            const delta = 2;
            const left = currentPage - delta;
            const right = currentPage + delta + 1;
            let last = 0;

            for (let i = 1; i <= totalPages; i++) {
                if (i === 1 || i === totalPages || (i >= left && i < right)) {
                    if (last && i - last > 1) {
                        buttons.push(<li key={`ellipsis-${i}`} className="page-item disabled"><span className="page-link">…</span></li>);
                    }
                    buttons.push(
                        <li key={i} className={`page-item${i === currentPage ? ' active' : ''}`}>
                            <button className="page-link" onClick={() => handlePageClick(i)}>{i}</button>
                        </li>
                    );
                    last = i;
                }
            }
            return buttons;
        };

        return (
            <>
                <div className="common-table superadmin_table">
                    <StyledTableWrapper>
                        <div className="custom-table-style table-fields">
                            {data && data.length > 0 ? (
                                data.map((row, rowIndex) => (
                                    <div key={row.student_uuid || rowIndex} className="table-row">
                                        {columns.map((col, colIndex) => (
                                            <div key={colIndex}>
                                                {col.formatter
                                                    ? col.formatter(row[col.dataField], row, rowIndex)
                                                    : row[col.dataField]}
                                            </div>
                                        ))}
                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-gray-400 p-3">No records found</div>
                            )}
                        </div>
                    </StyledTableWrapper>
                </div>

                <div className="d-flex flex-stack justify-content-between flex-wrap pt-3 pagination-main">
                    {totalSize > 0 && (
                        <div className="pagination_limt">
                            <select
                                id='select'
                                name='group'
                                className='form-control input-sm form-select form-select-sm form-select-solid'
                                size='1'
                                value={perpagedata}
                                onChange={(event) => setPerpagePagination(event)}
                            >
                                <option value={totalSize}>All</option>
                                <option value={12}>12</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                            </select>
                            <div className="count_number">
                                {(() => {
                                    const total = Number.isFinite(Number(props.statusDefaultCount)) ? Number(props.statusDefaultCount) : 0;
                                    const pageNum = Math.max(1, Number(currentPage));
                                    const limit = Number.isFinite(Number(sizePerPage)) && Number(sizePerPage) > 0 ? Number(sizePerPage) : total;

                                    if (!limit || total === 0) return `Displaying ${data?.length || 0} of ${total} records`;
                                    if (limit >= total) return `Displaying 1–${total} of ${total} records`;

                                    const start = Math.min(total, Math.max(1, (pageNum - 1) * limit + 1));
                                    const end = Math.min(total, pageNum * limit);
                                    return `Displaying ${start}–${end} of ${total} records`;
                                })()}
                            </div>
                        </div>
                    )}
                    {totalSize > 0 && totalPages > 1 && (
                        <div className="pagination_page">
                            <ul className="pagination react-bootstrap-table-page-btns-ul">
                                <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageClick(currentPage - 1)}>&lt;</button>
                                </li>
                                {renderPageButtons()}
                                <li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageClick(currentPage + 1)}>&gt;</button>
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </>
        );
    };
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xl-12 ">
                    <StyledTableWrapper studentListCount={props?.StudentListcount} >
                        <div id="std-details-wraps" className="dataTables_wrapper dt-bootstrap4 no-footer team-list-table cstmmmm-table">
                            <div className="card-body p-0 bg-white radious-style radious-users">
                                
                                <RemotePagination
                                    data={props.data}
                                    columns={columns}
                                    totalSize={props.StudentListcount}
                                    page={props.filterpage}
                                    sizePerPage={props.filterlimit === "" ? props.StudentListcount : props.filterlimit}
                                    order={props.filterorder}
                                    dataField={props.filtersort}
                                    onTableChange={handleTableChange}
                               

                                />
                               
                            </div>
                        </div>
                    </StyledTableWrapper>
                </div>
            </div>

        </React.Fragment>
    );
};
export default SnapshotItem;